var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBillingWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_1109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 19.25V4.58333C5 4.0971 5.21071 3.63079 5.58579 3.28697C5.96086 2.94315 6.46957 2.75 7 2.75H17C17.5304 2.75 18.0391 2.94315 18.4142 3.28697C18.7893 3.63079 19 4.0971 19 4.58333V19.25L16 17.4167L14 19.25L12 17.4167L10 19.25L8 17.4167L5 19.25Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.33337H11.5C11.1022 7.33337 10.7206 7.47824 10.4393 7.7361C10.158 7.99396 10 8.3437 10 8.70837C10 9.07305 10.158 9.42278 10.4393 9.68065C10.7206 9.93851 11.1022 10.0834 11.5 10.0834H12.5C12.8978 10.0834 13.2794 10.2282 13.5607 10.4861C13.842 10.744 14 11.0937 14 11.4584C14 11.823 13.842 12.1728 13.5607 12.4306C13.2794 12.6885 12.8978 12.8334 12.5 12.8334H10M12 12.8334V14.2084M12 5.95837V7.33337",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_1109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillingWhite);
export default __webpack_public_path__ + "static/media/Icon_Billing_White.8578f0745f0b0d81536627f196713c23.svg";
export { ForwardRef as ReactComponent };